import React, { Component } from "react";
import { Layout, Menu, Tooltip, Avatar, Badge } from "antd";
import {
  HomeOutlined,
  MenuOutlined,
  MenuFoldOutlined,
  WechatOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  ContainerOutlined,
  QqCircleFilled,
  ProfileOutlined,
  UserAddOutlined,
  QuestionCircleFilled
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import logo_Final from "../../images/logo_Final_cut.png";
import { FirebaseRef } from "../../lib/firebase";
import { BackButton } from "./BackButton";
import "./layout.scss";

const { Header, Sider, Content } = Layout;

class LayoutManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      docterList: [],
    };
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  componentDidMount() {
    let ref = FirebaseRef.child(`/reQuest`);
    ref.on("value", (snapshot) => {
      const data = snapshot.val();
      if (data && typeof data === "object") {
        let newData = [];

        Object.keys(data).forEach((key) => {
          if (data[key] && data[key].status === "pending") {
            newData.push({
              ...data[key],
              id: key,
            });
          }
        });
        const newArray = newData.reverse();

        this.setState({
          docterList: newArray,
        });
      }
    });
  }

  render() {
    const { Component, history, member, active, logout, isBack } = this.props;
    const newId = this.props.match.params.id;
    const { docterList } = this.state;
    console.log("Layout");
    return (
      <Layout>
        <Sider trigger={null} collapsible collapsed={this.state.collapsed}>
          <div className="logo logoImg-admin">
            <Link to={"/"}>
              <img
                src={logo_Final}
                alt="Angelo Network"
                width="70"
                height="70"
                style={{ marginBottom: "20px", marginLeft: "10px" }}
              />
            </Link>
            {/* <span className="layout-text">Manage</span> */}
          </div>
          {member.role === "dev" || member.role === "admin" ? (
            <Menu
              theme="dark"
              mode="inline"
              selectedKeys={[active === "4" && newId ? newId : active]}
            >
              <Menu.Item
                onClick={() => {
                  history.push("/manage/live-chat");
                }}
                key="1"
              >
                <WechatOutlined type="wechat" />

                <span>Live Chat</span>
              </Menu.Item>
              <Menu.Item
                onClick={() => {
                  history.push("/manage/home");
                }}
                key="2"
              >
                <HomeOutlined />
                <span>Request GenC Health-Box</span>
              </Menu.Item>
              <Menu.Item
                onClick={() => {
                  history.push("/manage/applications");
                }}
                key="3"
              >
                <AppstoreAddOutlined />
                <span>Application</span>
              </Menu.Item>
              <Menu.Item
                onClick={() => {
                  history.push("/manage/Member-Notifications/detail");
                }}
                key="Member-Notifications"
              >
                <ContainerOutlined />
                <span>Member Notifications</span>
              </Menu.Item>
              <Menu.Item
                onClick={() => {
                  history.push("/manage/GenC-Labs/detail");
                }}
                key="GenC-Labs"
              >
                <ContainerOutlined />
                <span>GenC Labs Inc. Updates</span>
              </Menu.Item>
              <Menu.Item
                onClick={() => {
                  history.push("/manage/Developer-Newsletter/detail");
                }}
                key="Developer-Newsletter"
              >
                <ContainerOutlined />
                <span>Developer Newsletter</span>
              </Menu.Item>
              <Menu.Item
                onClick={() => {
                  history.push("/manage/GenC-Snacks/detail");
                }}
                key="GenC-Snacks"
              >
                <ContainerOutlined />
                <span>GenC Snacks</span>
              </Menu.Item>
              <Menu.Item
                onClick={() => {
                  history.push("/manage/topics");
                }}
                key="8"
              >
                <QuestionCircleFilled />
                <span>Topics</span>
              </Menu.Item>
              <Menu.Item
                onClick={() => {
                  history.push("/manage/questions");
                }}
                key="5"
              >
                <QqCircleFilled />
                <span>Questions</span>
              </Menu.Item>
              <Menu.Item
                onClick={() => {
                  history.push("/manage/profile");
                }}
                key="6"
              >
                <ProfileOutlined />
                <span>Profile</span>
              </Menu.Item>
              <Menu.Item
                onClick={() => {
                  history.push("/manage/circle-user");
                }}
                key="7"
              >
                <UserAddOutlined />
                <span>Circle User</span>
              </Menu.Item>
            </Menu>
          ) : (
              <Menu
                theme="dark"
                mode="inline"
                selectedKeys={[active === "4" && newId ? newId : active]}
              >
                <Menu.Item
                  onClick={() => {
                    history.push("/manage/profile");
                  }}
                  key="6"
                >
                  <ProfileOutlined />
                  <span>Profile</span>
                </Menu.Item>
                <Menu.Item
                  onClick={() => {
                    history.push("/manage/circle-user");
                  }}
                  key="7"
                >
                  <UserAddOutlined />
                  <span>Circle User</span>
                </Menu.Item>
                <Menu.Item
                  onClick={() => {
                    history.push("/manage/questions");
                  }}
                  key="5"
                >
                  <QqCircleFilled />
                  <span>Questions</span>
                </Menu.Item>
              </Menu>
            )}
        </Sider>
        <Layout>
          <Header
            style={{
              background: "#fff",
              padding: 0,
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.state.collapsed ? (
              <MenuOutlined
                className="trigger"
                onClick={this.toggle}
              ></MenuOutlined>
            ) : (
                <MenuFoldOutlined
                  onClick={this.toggle}
                  className="trigger"
                ></MenuFoldOutlined>
              )}
            {isBack ? (
              <div
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <BackButton {...this.props} title="Back"></BackButton>
              </div>
            ) : null}

            <div
              style={{
                width: "100%",
                textAlign: "right",
                marginRight: "20px",
                cursor: "pointer",
              }}
            >
              <span style={{ marginRight: "10px" }}>
                <Badge
                  onClick={() => {
                    history.push(
                      member.role !== "user"
                        ? "/manage/home"
                        : "/manage/circle-user"
                    );
                  }}
                  count={docterList.length}
                >
                  <Avatar
                    src={member.imgUrl || ""}
                    style={{ backgroundColor: "#87d068" }}
                    icon={<UserOutlined />}
                  />
                </Badge>
              </span>
              <span
                onClick={() => {
                  history.push("/");
                  logout();
                }}
              >
                <Tooltip title="Log out">
                  Hi,{" "}
                  {member.nickname && member.nickname !== ""
                    ? member.nickname
                    : member.email}{" "}
                </Tooltip>
              </span>
            </div>
          </Header>
          <Content
            style={{
              margin: "24px 16px",
              padding: 24,
              background: "#fff",
              minHeight: "100vh",
            }}
          >
            <Component {...this.props} member={member} />
          </Content>
        </Layout>
      </Layout>
    );
  }
}

export default LayoutManage;
